import styled, { css } from "styled-components";

import { NexusGroupImageContainer } from "pages/[tenant]/g/[group_slug]/classwork/components/templates/ClassworkPageImersiveLayout/components/molecules/GroupNexusContent/components/atoms/NexusGroupImage/styles";

export const GroupNexusContainer = styled.div`
  margin-top: 2rem;
`;

export const GroupNexusContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.4375rem;

  grid-column: 1 / -1;
`;

interface INexusDropdownContentProps {
  orientation: "vertical" | "horizontal";
}

export const NexusDropdownContent = styled.div<INexusDropdownContentProps>`
  display: grid;
  grid-template-columns: repeat(5, minmax(140px, 268px));
  gap: 1.4375rem;

  margin: 0;

  max-height: 0px;
  overflow: hidden;
  transition: 0.5s all;

  @media (max-width: 1100px) {
    grid-template-columns: repeat(4, minmax(140px, 247px));
  }

  @media (max-width: 850px) {
    grid-template-columns: repeat(3, minmax(140px, 275px));
  }

  @media (max-width: 600px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 500px) {
    grid-template-columns: 1fr 1fr;
  }

  li {
    list-style: none;
  }

  ${NexusGroupImageContainer} {
    aspect-ratio: ${({ orientation }) =>
      orientation === "vertical" ? "9 / 12" : "16 / 9"};
  }

  ${({ orientation }) =>
    orientation === "vertical" &&
    css`
      @media (max-width: 500px) {
        ${NexusGroupImageContainer} {
          max-height: 300px !important;
        }
      }
    `}
`;
